import { FlexContext } from '#app/components/Layout/components/Flex/context.js';
import { type ColProps } from '../Col/types.js';
import { StyledRow } from './Row.styles.js';
import { createContext, type ReactElement, useContext, useMemo } from 'react';

const DEFAULT_GAP = 24;

const RowContext = createContext({ gap: DEFAULT_GAP });

type RowProps = {
  readonly children: Array<ReactElement<ColProps>> | ReactElement<ColProps>;
};

export const Row = ({ children, ...props }: RowProps) => {
  const { gap, reversed } = useContext(FlexContext);

  const context = useMemo(() => {
    return {
      gap,
    };
  }, [gap]);

  return (
    <RowContext.Provider value={context}>
      <StyledRow
        $gap={gap}
        $reversed={reversed}
        {...props}
      >
        {children}
      </StyledRow>
    </RowContext.Provider>
  );
};

Row.displayName = 'Flex.Row';
